// eslint-disable-next-line max-classes-per-file
import { ReactNode, useEffect } from "react";
import Registry from "../../base-registry";
import TicketItem from "./ticket-item";

export enum ActionType {
    CLOSE = "CLOSE",
    IGNORE = "IGNORE",
    MARK_UNREAD = "MARK_UNREAD",
    MARK_READ = "MARK_READ",
    SNOOZE = "SNOOZE",
    HOLD = "HOLD",
    STOP_HOLD = "STOP_HOLD",
    TRANSFER = "TRANSFER",
    ASSIGN = "ASSIGN",
    ASSIGN_SELF = "ASSIGN_SELF",
    UNASSIGN = "UNASSIGN",
    STORE_TICKET_COLUMN = "STORE_TICKET_COLUMN",
    SEND_MESSAGES = "SEND_MESSAGES",
    MOVE = "MOVE",
    ADD_PARTICIPANTS = "ADD_PARTICIPANTS",
}

export enum ActionContext {
    BULK_ACTION = "BULK_ACTION",
    TICKET_ACTION = "TICKET_ACTION",
}

export interface HandlerButtonCreatorProps {
    button: HandlerButton;
    onClick(): void
}
export interface HandlerButton {
    sortIndex?: number;
    text: string;
    icon: ReactNode;
    canNotOverflow?: boolean;
    variant: "primary" | "ghost-gray" | "danger";
    render?: (props: HandlerButtonCreatorProps) => ReactNode;
}

export class ActionHandler {
    private handleComplete: (() => void) | undefined;

    constructor(
        private _items: TicketItem[],
        public readonly context: ActionContext,
        onCompleted?: () => void,
        private onRollback?: () => void,
    ) {
        this.handleComplete = onCompleted;
    }

    get items() {
        return this._items;
    }

    done() {
        this.handleComplete?.();
        this.handleComplete = undefined;
    }

    rollback() {
        this.onRollback?.();
    }
}

export interface Handler {
    createBulkActionButton?(items: TicketItem[], actionContext: ActionContext): HandlerButton | undefined;
    handleBulkAction(handler: ActionHandler): void;
}

export const ACTION_REGISTRY = new Registry<Handler>();
export const EVENTS: Record<ActionType, Registry<Handler>> = Object.create(null);

export const HANDLER_INTERFACE = new Registry<(...args: Record<string, unknown>[]) => ReactNode>();

export function useRegisterAction(handler: Handler, action: ActionType) {
    useEffect(() => {
        ACTION_REGISTRY.register(handler);
        if (action) {
            EVENTS[action] ??= new Registry<Handler>();
            EVENTS[action].register(handler);
        }
        return () => {
            ACTION_REGISTRY.unregister(handler);
            if (action) {
                EVENTS[action]?.unregister(handler);
            }
        };
    }, []);
}
